import React from "react";
import SimpleCRUD from "../../components/SimpleCRUD";

export default function PoinKategori() {
  return (
    <SimpleCRUD
      title="Kategori Poin Kinerja"
      endpoint="/poin-kategori"
      testidPrefix="poinkat"
      fields={[
        { key: "nama", label: "Nama Poin", required: true },
        { key: "deskripsi", label: "Deskripsi", type: "textarea" },
        { key: "max_poin", label: "Max Poin", type: "number", default: 100, required: true },
        { key: "status_aktif", label: "Status", type: "checkbox", default: true, checkboxLabel: "Aktif" },
      ]}
    />
  );
}
